import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faTrashAlt } from '@fortawesome/pro-light-svg-icons'

import { Button, Tools } from '@domain-group/suit-theme'

import type { UsePaginationRulePayload } from '@hooks/usePaginationRule'

import { confirmDelete } from '@functions/entity'

type PaginationRuleToolsProps = {
  paginationRulePayload: UsePaginationRulePayload,
}

const PaginationRuleTools = (props: PaginationRuleToolsProps) => {
  const { paginationRulePayload } = props

  const {
    callbacks: {
      deletePaginationRule: deleteFn,
    },
    loading,
  } = paginationRulePayload

  const confirmDeletePayload = {
    callbacks: { deleteFn },
    options: { shouldRedirect: true },
    strings: { entityName: 'Pagination Rule' },
  }

  return (
    <Tools>
      <Button
        buttonStyle="secondaryUtility"
        icon={<FontAwesomeIcon icon={faTrashAlt} />}
        loading={loading}
        // @ts-expect-error TS2345
        onClick={() => confirmDelete(confirmDeletePayload)}
        size="medium"
      >
        Delete Pagination Rule
      </Button>
    </Tools>
  )
}

export default PaginationRuleTools
